<template>
  <div>
    <google-map :sharer="sharer" :show-lengend="showLegend" map-style="elevation" :show-sites="false" :legend="legend" />
  </div>
</template>


<script>

import GoogleMapMixins from '@/mixins/GoogleMapMixins'
import NumberMixins from '@/mixins/NumberMixins'

import GoogleMap from '@/components/maps/GoogleMap'

export default {

  mixins: [GoogleMapMixins, NumberMixins],

  components: {
    GoogleMap
  },

  props: {
    sharer: {
      type: Number,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    showSites: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    mapExpiryIcon (exp) {

      if (exp === null) {
        return this.greyIcon()
      }

      exp = Number(exp)

      if (exp <= 30) {
        return this.redIcon()
      }

      if (exp >= 31 && exp <= 365) {
        return this.yellowIcon()
      }

      if (exp >= 365 && exp <= 729) {
        return this.blueIcon()
      }

      if (exp >= 730) {
        return this.greenIcon()
      }
    },


    expiryStatus (m) {
      return m.content.siteName +
      (m.content.sharers ? ' | Sharers: ' + m.content.sharers + ' | ' : '') +
      (m.content.structureType
        ? (m.content.structureType + (m.content.structureHeight ? ' (' + m.content.structureHeight + 'm)' : '') + ' | ')
        : '') +
      (m.content.expiryDays
        ? (m.content.expiryDays > 0
            ? 'Expires in ' + this.formatInteger(m.content.expiryDays / 30) + ' months'
            : 'EXPIRED ' + this.formatInteger(Math.abs(m.content.expiryDays) / 30) + ' months ago')
         : 'No expiry date')
    }

  },

  data () {
    return {
      legend: {
        title: 'Expiry',
        statusFormatter: this.expiryStatus,
        mapIcon: this.mapExpiryIcon,
        prop: 'expiryDays'
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// TenancyExpiryMap.vue?3a79771c